<template>
    <div>

        <b-modal id="yeniKampTeklif"
                 ref="modal"
                 title="Yeni Kamp Yeri Teklifi"
                 @show="resetModal"
                 @hidden="resetModal"
                 @ok="handleOk"
        >
            <form ref="form" @submit.stop.prevent="handleSubmit">
                <b-form-group
                        :state="kampIsimState"
                        label="Kamp İsmi"
                        label-for="kampIsmiInput"
                        invalid-feedback="Kamp İsmi Gerekli">
                    <b-form-input
                            id="kampIsmiInput"
                            v-model="kampIsim"
                            :state="kampIsimState"
                            required
                    ></b-form-input>
                </b-form-group>
            </form>
        </b-modal>
    </div>


</template>

<script>
    import {kampIsmiTeklifEt} from "@/api/kamp"

    export default {
        name: "kampteklifform",
        data() {
            return {
                kampIsim: '',
                kampIsimState: null,
            }
        },
        methods: {
            checkFormValidity() {
                const valid = this.$refs.form.checkValidity()
                this.kampIsimState = valid
                return valid
            },
            resetModal() {
                this.kampIsim = ''
                this.kampIsimState = null
            },
            handleOk(bvModalEvt) {
                bvModalEvt.preventDefault()
                this.handleSubmit()
            },
            async handleSubmit() {
                if (!this.checkFormValidity()) {
                    return
                }

                const belgeLink = this.$route.fullPath;

                await kampIsmiTeklifEt(this.kampIsim, belgeLink)

                this.$nextTick(() => {
                    this.$bvModal.hide('yeniKampTeklif')
                })
            },
        }
    }
</script>

<style scoped>

</style>
